<template>
  <v-dialog v-model="dialog" persistent max-width="400">
    <v-card>
      <v-card-text class="pt-5 text-center">
        <p class="version-modal-title mb-1">Nuova versione disponibile</p>
        <p class="body-2">Ricarica la pagina per continuare.</p>
      </v-card-text>
      <v-card-actions class="justify-center pb-4">
        <v-btn color="primary" @click="reload">Ricarica</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "VersionModal",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    reload() {
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.version-modal-title {
  font-size: 1.15rem;
  font-family: Roboto, sans-serif;
  font-weight: 400;
  letter-spacing: 0.0125em;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.87);
}
</style>
